// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from './client';
import type { MvpApiListProductsData, MvpApiListProductsResponses, MvpApiCreateNewProductsData, MvpApiCreateNewProductsResponses, MvpApiGetProductData, MvpApiGetProductResponses, MvpApiSearchProductsData, MvpApiSearchProductsResponses, MvpApiUploadProductImageData, MvpApiUploadProductImageResponses, MvpApiListPlanogramsData, MvpApiListPlanogramsResponses, MvpApiCreateNewPlanogramsData, MvpApiCreateNewPlanogramsResponses, MvpApiListUniquePlanogramDescriptionsData, MvpApiListUniquePlanogramDescriptionsResponses, MvpApiGetPlanogramData, MvpApiGetPlanogramResponses, MvpApiUpdatePlanogramData, MvpApiUpdatePlanogramResponses, MvpApiGetPlanogramSummaryData, MvpApiGetPlanogramSummaryResponses, MvpApiGetPlanogramProductData, MvpApiGetPlanogramProductResponses, MvpApiUploadPlanogramImageData, MvpApiUploadPlanogramImageResponses, MvpApiListStorePlanogramsData, MvpApiListStorePlanogramsResponses, MvpApiCreateNewStorePlanogramData, MvpApiCreateNewStorePlanogramResponses, MvpApiGetStorePlanogramData, MvpApiGetStorePlanogramResponses, MvpApiUpdateStorePlanogramData, MvpApiUpdateStorePlanogramResponses, MvpApiListSuppliersData, MvpApiListSuppliersResponses, MvpApiCreateNewSuppliersData, MvpApiCreateNewSuppliersResponses, MvpApiListRetailersData, MvpApiListRetailersResponses, MvpApiGetRetailerData, MvpApiGetRetailerResponses, MvpApiListStoresData, MvpApiListStoresResponses, MvpApiGetStoreData, MvpApiGetStoreResponses, MvpApiListPlanogramGroupsData, MvpApiListPlanogramGroupsResponses, MvpApiCreateNewPlanogramGroupData, MvpApiCreateNewPlanogramGroupResponses, MvpApiListPlanogramGroupsWithMissingProductImageCountData, MvpApiListPlanogramGroupsWithMissingProductImageCountResponses, MvpApiListUniquePlanogramGroupNamesData, MvpApiListUniquePlanogramGroupNamesResponses, MvpApiGetPlanogramGroupData, MvpApiGetPlanogramGroupResponses, MvpApiUpdatePlanogramGroupData, MvpApiUpdatePlanogramGroupResponses, MvpApiListProductImagesData, MvpApiListProductImagesResponses, MvpApiCreateProductIssueData, MvpApiCreateProductIssueResponses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List Products
 */
export const mvpApiListProducts = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListProductsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListProductsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/products',
        ...options
    });
};

/**
 * Create New Products
 */
export const mvpApiCreateNewProducts = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateNewProductsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateNewProductsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/products',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Product
 */
export const mvpApiGetProduct = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetProductData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetProductResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/products/{product_id}',
        ...options
    });
};

/**
 * Search Products
 */
export const mvpApiSearchProducts = <ThrowOnError extends boolean = false>(options: Options<MvpApiSearchProductsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiSearchProductsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/products/search',
        ...options
    });
};

/**
 * Upload Product Image
 */
export const mvpApiUploadProductImage = <ThrowOnError extends boolean = false>(options: Options<MvpApiUploadProductImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiUploadProductImageResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/products/upload-image',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * List Planograms
 */
export const mvpApiListPlanograms = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListPlanogramsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListPlanogramsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/planograms',
        ...options
    });
};

/**
 * Create New Planograms
 */
export const mvpApiCreateNewPlanograms = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateNewPlanogramsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateNewPlanogramsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/planograms',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Unique Planogram Descriptions
 */
export const mvpApiListUniquePlanogramDescriptions = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListUniquePlanogramDescriptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListUniquePlanogramDescriptionsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/unique-planogram-descriptions',
        ...options
    });
};

/**
 * Get Planogram
 */
export const mvpApiGetPlanogram = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetPlanogramData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetPlanogramResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/planograms/{planogram_id}',
        ...options
    });
};

/**
 * Update Planogram
 */
export const mvpApiUpdatePlanogram = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdatePlanogramData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<MvpApiUpdatePlanogramResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/planograms/{planogram_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Planogram Summary
 */
export const mvpApiGetPlanogramSummary = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetPlanogramSummaryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetPlanogramSummaryResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/planograms/{planogram_id}/summary',
        ...options
    });
};

/**
 * Get Planogram Product
 */
export const mvpApiGetPlanogramProduct = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetPlanogramProductData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetPlanogramProductResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/planograms/{planogram_id}/products/{planogram_product_id}',
        ...options
    });
};

/**
 * Upload Planogram Image
 */
export const mvpApiUploadPlanogramImage = <ThrowOnError extends boolean = false>(options: Options<MvpApiUploadPlanogramImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiUploadPlanogramImageResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/planograms/upload-image',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * List Store Planograms
 */
export const mvpApiListStorePlanograms = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListStorePlanogramsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListStorePlanogramsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/store-planograms',
        ...options
    });
};

/**
 * Create New Store Planogram
 */
export const mvpApiCreateNewStorePlanogram = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateNewStorePlanogramData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateNewStorePlanogramResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/store-planograms',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Store Planogram
 */
export const mvpApiGetStorePlanogram = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetStorePlanogramData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetStorePlanogramResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/store-planograms/{store_planogram_id}',
        ...options
    });
};

/**
 * Update Store Planogram
 */
export const mvpApiUpdateStorePlanogram = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdateStorePlanogramData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<MvpApiUpdateStorePlanogramResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/store-planograms/{store_planogram_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Suppliers
 */
export const mvpApiListSuppliers = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListSuppliersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListSuppliersResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/suppliers',
        ...options
    });
};

/**
 * Create New Suppliers
 */
export const mvpApiCreateNewSuppliers = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateNewSuppliersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateNewSuppliersResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/suppliers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Retailers
 */
export const mvpApiListRetailers = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListRetailersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListRetailersResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/retailers',
        ...options
    });
};

/**
 * Get Retailer
 */
export const mvpApiGetRetailer = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetRetailerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetRetailerResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/retailers/{retailer_id}',
        ...options
    });
};

/**
 * List Stores
 */
export const mvpApiListStores = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListStoresResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/stores',
        ...options
    });
};

/**
 * Get Store
 */
export const mvpApiGetStore = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetStoreResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/stores/{store_id}',
        ...options
    });
};

/**
 * List Planogram Groups
 */
export const mvpApiListPlanogramGroups = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListPlanogramGroupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListPlanogramGroupsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/planogram-groups',
        ...options
    });
};

/**
 * Create New Planogram Group
 */
export const mvpApiCreateNewPlanogramGroup = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateNewPlanogramGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateNewPlanogramGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/planogram-groups',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Planogram Groups With Missing Product Image Count
 * Get all planogram groups with their missing image counts in a single query.
 * Returns a list of dictionaries with id, name, missing_product_image_count, and total_product_count.
 *
 * [
 * { "id": "...", "name": "SKINCARE, DRY", "missing_product_image_count": 26, "total_product_count": 455 },
 * { "id": "...", "name": "HAIRCARE, COLOURS", "missing_product_image_count": 24, "total_product_count": 418 },
 * ...
 * ]
 */
export const mvpApiListPlanogramGroupsWithMissingProductImageCount = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListPlanogramGroupsWithMissingProductImageCountData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListPlanogramGroupsWithMissingProductImageCountResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/planogram-groups-with-missing-product-image-count',
        ...options
    });
};

/**
 * List Unique Planogram Group Names
 */
export const mvpApiListUniquePlanogramGroupNames = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListUniquePlanogramGroupNamesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListUniquePlanogramGroupNamesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/unique-planogram-groups-names',
        ...options
    });
};

/**
 * Get Planogram Group
 */
export const mvpApiGetPlanogramGroup = <ThrowOnError extends boolean = false>(options: Options<MvpApiGetPlanogramGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<MvpApiGetPlanogramGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/planogram-groups/{planogram_group_id}',
        ...options
    });
};

/**
 * Update Planogram Group
 */
export const mvpApiUpdatePlanogramGroup = <ThrowOnError extends boolean = false>(options: Options<MvpApiUpdatePlanogramGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<MvpApiUpdatePlanogramGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/planogram-groups/{planogram_group_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Product Images
 */
export const mvpApiListProductImages = <ThrowOnError extends boolean = false>(options?: Options<MvpApiListProductImagesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MvpApiListProductImagesResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/product-images',
        ...options
    });
};

/**
 * Create Product Issue
 */
export const mvpApiCreateProductIssue = <ThrowOnError extends boolean = false>(options: Options<MvpApiCreateProductIssueData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MvpApiCreateProductIssueResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/v0/product-issues',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};